// Chat Bubble + Presentation Card — small presentational helpers
// extracted from DesignStudio.jsx (Feb 2026 refactor)

export function ChatBubble({ text, isUser, isSystem }) {
  return (
    <div className={`mb-3 ${isUser ? 'text-right' : 'text-left'}`}>
      <div className={`inline-block max-w-[90%] px-4 py-2.5 rounded-2xl text-sm ${
        isUser
          ? 'bg-gradient-to-r from-blue-600 to-violet-600 text-white rounded-br-md'
          : isSystem
            ? 'bg-slate-800/50 text-slate-300 border border-slate-700'
            : 'bg-slate-800 text-slate-200 rounded-bl-md'
      }`}>
        {text}
      </div>
    </div>
  );
}

export function PresentationCard({ title, icon: Icon, children, color = 'blue' }) {
  const colors = {
    blue: 'from-blue-500/20 to-blue-600/10 border-blue-500/30',
    green: 'from-green-500/20 to-green-600/10 border-green-500/30',
    purple: 'from-purple-500/20 to-purple-600/10 border-purple-500/30',
    orange: 'from-orange-500/20 to-orange-600/10 border-orange-500/30',
    red: 'from-red-500/20 to-red-600/10 border-red-500/30',
    cyan: 'from-cyan-500/20 to-cyan-600/10 border-cyan-500/30',
  };

  return (
    <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-4`}>
      <div className="flex items-center gap-2 mb-3">
        <Icon className={`w-5 h-5 text-${color}-400`} />
        <h4 className="font-semibold text-white">{title}</h4>
      </div>
      {children}
    </div>
  );
}
